var $ = require("jquery");
var objectFitImages = require("object-fit-images");
var Cookies = require("js-cookie");

// fitvids

let fitvids = require("fitvids");
fitvids(".basic-content");

// match height of cards

require("jquery-match-height");
$(".card__content").matchHeight();

// primary nav mobile toggle

$(".primary-nav__toggle a").on("click", function() {
    $(this)
        .closest(".primary-nav")
        .toggleClass("primary-nav--active");
});

$(".search-nav__toggle a").on("click", function() {
    $(this)
        .parents(".primary-nav__toggle-container")
        .siblings(".search-form")
        .toggleClass("active")
        .find("input[title=Search]")
        .focus();
});

$(".search-toggle").on("click", function() {
    $(".search-form").toggleClass("active");
    $('.search-form input[type="text"]').focus();
});

$(".expandable-links .link-section-toggle").on("click", function(e) {
    e.preventDefault();
    $(this)
        .parents(".link-section-wrap")
        .toggleClass("active");
});

// map stuff
$(document).ready(function() {
    initMap();
    objectFitImages();

    // if( $('body').hasClass('logged-in') == false ) {
    //     initExitSurvey();
    // }
});

var initExitSurvey = function() {
    var pageViewCount = 0;

    if (Cookies.get("adwSchoolsPageViewCount")) {
        pageViewCount = parseInt(Cookies.get("adwSchoolsPageViewCount"));
    }

    pageViewCount = pageViewCount + 1;

    Cookies.set("adwSchoolsPageViewCount", pageViewCount);

    if (
        pageViewCount >= 4 &&
        Cookies.get("adwSchoolsHasSeenExitSurvey") != "yes"
    ) {
        $(document).on("mouseout", evt => {
            if (evt.toElement === null || evt.relatedTarget === null) {
                $(evt.currentTarget).off("mouseout");
                $("body").addClass("show-exit-survey");
                Cookies.set("adwSchoolsHasSeenExitSurvey", "yes");
            }
        });
    }

    $(".exit-survey .close").on("click", function(e) {
        e.preventDefault();
        $("body").removeClass("show-exit-survey");
        Cookies.set("adwSchoolsHasSeenExitSurvey", "yes");
    });
};

$("body").on("click", "a[href^=http]", function() {
    if (this.href.indexOf(location.hostname) == -1) {
        $(this).attr("target", "_blank");
    }
});

$(".school-listing__school-title a").attr("target", "_blank");

var initMap = function() {
    // view toggle
    var map;
    $(".view-toggles a").on("click", function(e) {
        e.preventDefault();
        $(".view-toggles a.active").removeClass("active");
        $(this).addClass("active");

        if ($(this).attr("data-show") == "map") {
            $(".school-finder--list").removeClass("active");
            $(".school-finder--map").addClass("active");
            $(this)
                .parents(".school-finder")
                .removeClass("list-visible");
            $(this)
                .parents(".school-finder")
                .addClass("map-visible");
            center_map(map);
        } else {
            $(".school-finder--map").removeClass("active");
            $(".school-finder--list").addClass("active");
            $(this)
                .parents(".school-finder")
                .addClass("list-visible");
            $(this)
                .parents(".school-finder")
                .removeClass("map-visible");
        }
    });

    // expandables
    $(".expandable .title").click(function() {
        var wrapper = $(this).parent(".expandable");

        wrapper.toggleClass("active");

        $(this).attr("aria-expanded", function(index, attr) {
            return attr == "false" ? "true" : "false";
        });
    });

    function new_map($el) {
        // vars
        var latlng = new google.maps.LatLng(37.09024, -95.712891);
        var args = {
            zoom: 13,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            zoomControl: true
        };

        // create map
        map = new google.maps.Map($el[0], args);

        $(window).on("resize", function() {
            google.maps.event.trigger(map, "resize");
        });

        // add a markers reference
        map.markers = [];

        refresh_markers($el, map);

        jQuery(document).on("facetwp-refresh", function() {
            $(".school-finder").addClass("loading");
        });

        jQuery(document)
            .on("facetwp-loaded", function(obj) {
                $(".school-finder").removeClass("loading");
                refresh_markers($el, map);

                // no results
                if ($(".school-finder--list .marker").length == 0) {
                    $(".school-finder--map, .school-finder--list").append(
                        '<div class="no-results-message">No results found.</div>'
                    );
                } else {
                    $(".school-finder--map .no-results-message").remove();
                }

                // if there any active facets show clear link
                var activeFacets = false,
                    resetLink = $(".filter-heading-reset"),
                    currentSelectedGrades = FWP.facets.grade_level;

                if (typeof currentSelectedGrades[0] !== "undefined") {
                    $(".archive-filter").removeClass(
                        "selected-grade-preschool selected-grade-elementary selected-grade-high-school"
                    );
                    $(".archive-filter").addClass(
                        "selected-grade-" + currentSelectedGrades[0]
                    );
                }

                for (var facet in FWP.facets) {
                    if (FWP.facets.hasOwnProperty(facet)) {
                        if (FWP.facets[facet].length) {
                            activeFacets = true;
                        }
                    }
                }

                if (
                    activeFacets &&
                    typeof currentSelectedGrades[0] !== "undefined"
                ) {
                    $(".archive-filter")
                        .removeClass("hide-filters")
                        .addClass("show-filters");
                    resetLink.show();
                } else {
                    $(".archive-filter")
                        .removeClass("show-filters")
                        .addClass("hide-filters");
                    resetLink.hide();
                }

                $(".archive-filter").show();

                // if there are any groups with no facets available, hide the group
                $(
                    ".archive-filter .expandable, .archive-filter .expandable .sub-group"
                ).addClass("show");
                $(
                    ".archive-filter .expandable, .archive-filter .expandable .sub-group"
                ).each(function() {
                    var parent = $(this);
                    if (parent.find(".facetwp-facet").children().length == 0) {
                        parent.removeClass("show");
                    }
                });
            })
            .trigger("facetwp-loaded");

        // return
        return map;
    }

    function refresh_markers($el, map) {
        // remove all markers
        for (var i = 0; i < map.markers.length; i++) {
            map.markers[i].setMap(null);
        }
        map.markers = [];

        // select markers in div that gets refreshed by facetwp
        var $markers = $(
            ".school-finder--list .marker, .school-detail-map .marker"
        );

        // add markers
        $markers.each(function() {
            add_marker($(this), map);
        });

        center_map(map);
    }

    /*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type  function
     *  @date  8/11/2013
     *  @since 4.3.0
     *
     *  @param $marker (jQuery element)
     *  @param map (Google Map object)
     *  @return  n/a
     */
    var openInfoWindow = null;

    function add_marker($marker, map) {
        // create marker
        var latlng = new google.maps.LatLng(
            $marker.attr("data-lat"),
            $marker.attr("data-lng")
        );
        var icon = {
            url: "/wp-content/themes/adwschools/assets/images/marker.png",
            size: new google.maps.Size(24, 24),
            scaledSize: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(24, 24)
        };
        var marker = new google.maps.Marker({
            position: latlng,
            icon: icon,
            map: map,
            optimized: false
        });

        // add to array
        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, "click", function() {
                if (openInfoWindow) {
                    openInfoWindow.close();
                }
                openInfoWindow = infowindow;
                infowindow.open(map, marker);
            });
        }
    }

    /*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type  function
     *  @date  8/11/2013
     *  @since 4.3.0
     *
     *  @param map (Google Map object)
     *  @return  n/a
     */

    function center_map(map) {
        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function(i, marker) {
            var latlng = new google.maps.LatLng(
                marker.position.lat(),
                marker.position.lng()
            );

            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else {
            // fit to bounds
            map.fitBounds(bounds);
            // if( map.markers.length <= 3 ) {
            //   map.setZoom(12);
            //   alert('here');
            // }
        }
    }
    if ($(".school-finder").length) {
        $(".school-finder").each(function() {
            // create map
            var map = new_map($(this).find(".map"));
        });
    }

    if ($(".school-detail-map").length) {
        $(".school-detail-map").each(function() {
            // create map
            var map = new_map($(this).find(".map"));
        });
    }
};

$(".expandable-list .item__headline.with-content").on("click", function() {
    $(this)
        .find(".expand-toggle")
        .toggleClass("active");
    let additionalContent = $(this).siblings(".item__additional-content");
    let height = additionalContent[0].scrollHeight;
    additionalContent.toggleClass("active");
    if (additionalContent.hasClass("active")) {
        additionalContent.css("max-height", height);
    } else {
        additionalContent.css("max-height", 0);
    }
});
